import React from 'react';
import TextView from '../../../TextView';
import { Stack } from '@mui/material';
import IyugaTooltip from '../../../IyugaTooltip';

function LinkItem({ link }) {
  return (
    <Stack
      mt={1}
      style={{
        backgroundColor: 'white',
        justifyContent: 'flex-start',
        padding: '5px',
        borderRadius: '4px',
        paddingLeft: '2px',
      }}
    >
      <IyugaTooltip tooltip={'Open Link'}>
        <TextView
          onClick={() => window.open(link, '_blank')} // Opens link in a new tab
          variant="largeText"
          color="#0058B8"
          style={{
            display: 'block', // Ensures proper block-level rendering
            whiteSpace: 'nowrap', // Prevents wrapping
            overflow: 'hidden', // Hides any overflow
            textOverflow: 'ellipsis', // Adds ellipsis at the end
            width: '100%', // Ensure it takes up the container width
            maxWidth: '90%', // Limit the maximum width to 90%
            cursor: 'pointer', // Pointer cursor to indicate clickable
            textDecoration: 'none', // Remove underline initially
            transition: 'text-decoration 0.3s ease', // Smooth underline animation
          }}
          onMouseEnter={(e) => (e.currentTarget.style.textDecoration = 'underline')} // Add underline on hover
          onMouseLeave={(e) => (e.currentTarget.style.textDecoration = 'none')} // Remove underline on hover out
        >
          {link}
        </TextView>
      </IyugaTooltip>
    </Stack>
  );
}

export default LinkItem;
